import React, { useEffect, useRef, useState } from "react"
import { columnsFn } from './data'
import type { OperateActionType, TableListItem } from './data'
import ProTable, { ActionType } from '@ant-design/pro-table';
import type { ModalFormProps, ProFormInstance } from '@ant-design/pro-form'
import { Modal, Radio, Table } from "antd";
import type { RadioChangeEvent } from 'antd';
import { cusAddApproveList, cusAddApprove, getMyCusAdd } from '@api/index'
import { productApi, strIsEmpty } from "@utils/util";
import { ProTableWithFormSetting } from "@components/index";
import { useHasAuthCode } from "@hooks/index";
import { set } from "lodash";
import { round } from "lodash";


const getApi = productApi(cusAddApproveList)
const getApi1 = productApi(getMyCusAdd)
export const tocusApproveApi = productApi(cusAddApprove)



export default () => {
    const [, hasAuthCode] = useHasAuthCode()
    const formRef = useRef<ProFormInstance>()
    const ref = useRef<ActionType>(null);
    const [type, setType] = useState<string>('1')
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dataSource, setDataSource] = useState<any[]>([])

    const operate = async (type: OperateActionType, record?: TableListItem | null, values?: any) => {

        if (type === '审批') {
            Modal.confirm({
                title: '确认审批',
                content: '确认同意该客户多云报备吗？',
                okText: '同意',
                cancelText: '拒绝',
                onOk: async () => {
                    console.log('确认')
                    await tocusApproveApi({ res: 1, id: record.id }, true, () => {
                        setTimeout(() => {
                            reFresh()
                        }, 1000)
                    })
                },
                onCancel: async () => {
                    console.log('拒绝')
                    await tocusApproveApi({ res: 0, id: record.id }, true, () => {
                        setTimeout(() => {
                            reFresh()
                        }, 1000)
                    })
                }
            });
        } else if (type === '查看审批') {
            setIsModalOpen(true)
            if (record) {
                setDataSource(record.list || [])
            }
        }
    }

    const getListApi = async (params: any, sorter: any, filter: any) => {
        if (type === '2') {
            const { data } = await getApi1({ ...params }, false)
            const { values, total } = data || {}
            return {
                data: values || [],
                success: true,
                total
            }
        } else {
            const { data } = await getApi({ ...params }, false)
            const { values, total } = data || {}
            return {
                data: values || [],
                success: true,
                total
            }
        }

    }
    const reFresh = () => {
        setTimeout(() => {
            // @ts-ignore
            ref.current?.clearSelected()
            ref.current?.reload()
        }, 1000)
    }
    // 切换
    const onChangeType = ({ target: { value } }: RadioChangeEvent) => {
        setType(value);
        // @ts-ignore
        ref.current?.clearSelected()
        // @ts-ignore
        ref.current?.reloadAndRest()
    };

    return <div>
        <div style={{ boxSizing: 'border-box' }}>
            <ProTableWithFormSetting<TableListItem>
                // scroll={{x: 1800}}
                scroll={{ x: 'max-content' }}
                columns={columnsFn(operate, type)}
                request={getListApi}
                options={{ reload: false, density: false }}
                headerTitle={<Radio.Group
                    options={[{ label: '带我审批', value: '1' }, { label: '我的报备', value: '2' }]}
                    onChange={onChangeType}
                    value={type}
                    optionType="button"
                    buttonStyle="solid"
                />}
                toolbar={{
                    actions: [],
                }}
                rowKey="id"
                formRef={formRef}
                actionRef={ref as any}
                pagination={{ defaultPageSize: 10 }}
                rowSelection={false}
                columnsState={{ persistenceKey: 'customer/contact', persistenceType: 'localStorage' }}
                searchState={{ persistenceKey: 'customer/contact:searchState', persistenceType: 'localStorage' }}
            />
        </div>
        <Modal title="审批进度" open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null}>
            <Table dataSource={dataSource} pagination={false} columns={[{
                title: '申批人',
                dataIndex: 'userName',
            },
            {
                title: '审批意见',
                dataIndex: 'res',
                render: (text: any) => strIsEmpty(text) ? '审批中' : ['拒绝', "通过"][text],
            }, {
                title: '审批时间',
                dataIndex: 'updateTime',
            },]} />
        </Modal>
    </div>
}


